import { Component, OnInit, Input, ChangeDetectorRef, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EditorService } from '../bookeditoption/editor.service';
import { EditOptionService } from '../bookeditoption/editOptions.service';
import { Book } from '../../shared/models/book';
import { BookData } from '../../shared/models/bookData';
import { EnrichmentPage } from '../../shared/models/enrichmentPage';
import { Page } from '../../shared/models/page';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css']
})
export class EditorComponent implements OnInit {

  @Input() pageContent: any;
  @Input() bookObj: Book;
  @Input() bookDataObj: BookData;
  @Input() currentLoadingPage: EnrichmentPage;
  @Input() pageObj: Page;
  @Input() rootTabActive: boolean;
  cardStyleProps: any = {};
  currentCard: any = {};
  cardJson: any = {};
  isPreview: any = true;
  currentApp:any = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NooorPreview/index.html');
  inlineContentData: any = {};
  isreload = true;
  commLayer: any = {};
  constructor(private editorService: EditorService, private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef, private ele: ElementRef, private domSanitizer: DomSanitizer, private editorOptionsService: EditOptionService) {
    // var pageData = localStorage.getItem('page');

    this.editorOptionsService.pageContentData$.subscribe(evt => {

      this.pageContent = evt.pageContent;

    });
  }

  // @Input()
  // set content(content: string) {
  //   console.log('prev value: ', this.pageContent);
  //   console.log('got name: ', content);
  //   this.pageContent = content;
  // }
  ngOnChanges(changes: SimpleChanges) {

    if (changes && changes.pageContent && changes.pageContent.currentValue)
      this.pageContent = changes.pageContent.currentValue;

    this.isreload = false;
    var self = this;
    setTimeout(() => {
      self.isreload = true;
    }, 100
    )
  }
  ngOnInit() {
    //alert('this.pageContent'+this.pageContent);
    this.editorService.editorData$.subscribe(evt => {
      this.updateEditor(evt);
    });
    document['native'] = this;
  }
  updateEditor(status) {
    if (status == "editable") {
      this.switchToEditor();
    } else if (status == "pagePreview") {
      if (this.isPreview == false) {
        this.isPreview = true;
        this.currentApp = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NooorPreview/index.html');
      }
    }
  }



  onLoadEditor() {
    console.log('angular');
  }


  typography() {

  }
  // let com;

  onLoadIframe(ev) {
    this.commLayer = this.editorService.getIframeReference();;
  }
  sendPageData() {
    if (this.currentApp.changingThisBreaksApplicationSecurity == "assets/NooorPreview/index.html") {
      this.editorService.callBookEditOpt("pagePreview");
    }
    var data = this.pageContent;

    if (data.pageBgStyle) {
      let pageBgStyleObj;
      if (typeof data.pageBgStyle == "object") {
        pageBgStyleObj = data.pageBgStyle;
      }
      // if 'data.pageBgStyle' is in string format
      else {
        pageBgStyleObj = JSON.parse(data.pageBgStyle);
      }
      if (pageBgStyleObj.url) {
        let _that = this;
        let img = new Image();
        let aspectRatio;
        let calculatedHeight;
        img.onload = function () {
          aspectRatio = this['width'] / this['height'];
          calculatedHeight = 980 / aspectRatio; //980px is width of div.pdfPageView
          data.pageStyle = { "height": calculatedHeight + 'px', "width": '968px' };
          _that.sendPageDataToEditor(data);
        };
        img.src = pageBgStyleObj.url;
      }
      else {
        this.sendPageDataToEditor(data);
      }
    }
    else {
      this.sendPageDataToEditor(data);
    }

  }

  sendPageDataToEditor(data) {
    let _that = this;
    _that.editorService.editorPageData = data;
    // this.onLoadIframe();
    _that.commLayer = _that.editorService.getIframeReference();
    _that.commLayer.setPageData(JSON.stringify(data), '', '3');
    setTimeout(() => {
      _that.ele.nativeElement.querySelector('.editorPreviewLoaderCon').style.visibility = "hidden";
    }, 100);
  }







  getCardData(cardObj) {
    this.currentCard = cardObj;

  }
  // getCardProperties(cardProps) {
  //   this.cardStyleProps = cardProps;
  //   this.editorService.editorCardObj = cardProps;
  //   //this.EditorService.getEditorCardData(cardProps);

  //   console.log(this.cardStyleProps);
  // }

  sendCardObject(obj) {
    let cardobj: any = JSON.parse(obj)
    this.cardJson = cardobj;
    this.editorService.getEditorData(cardobj);
    this.editorService.editorCardObj = cardobj;
  }
  switchToEditor() {
    this.isPreview = false;
    // this.ele.nativeElement.querySelector('.editorContainer')
    // this.currentApp = this.sanitizer.bypassSecurityTrustResourceUrl('assets/NooorEditor/app/index.html');
    this.currentApp = this.domSanitizer.bypassSecurityTrustResourceUrl("assets/NooorEditor/index.html");

  }

  onPageSave() {
    console.log('Page Saved Successfully....!!!');
  }
  savePageData(data) {
    console.log("from Editor" + data);
  }
  sendTextMediaContent(obj) {
    let inlinData: any = JSON.parse(obj)
    this.inlineContentData = inlinData;
    this.editorService.getEditorData(inlinData);
    setTimeout(() => {
      this.editorService.callBookEditOpt(inlinData);
    }, 0);
  }

  sendCardProperties(obj) {
    let cardProp: any = JSON.parse(obj)
    this.cardStyleProps = cardProp;
    this.editorService.editorCardObj = cardProp;
  }
  sendTextQuestionContent(obj) {
    let cardobj: any = JSON.parse(obj)
    this.cardJson = cardobj;
    this.editorService.getEditorData(cardobj);
    setTimeout(() => {
      this.editorService.callBookEditOpt(cardobj);
    }, 0);
  }



  // isEditorReady(isReady) {
  //   if (isReady) {
  //     this.sendPageData();
  //   }
  // }


  // isPreviewReady(isReady) {
  //   if (isReady) {
  //     this.sendPageData();
  //   }
  // }


  isStageReady(isReady) {
    this.ele.nativeElement.querySelector('.editorPreviewLoaderCon').style.visibility = "visible"
    if (isReady) {
      this.sendPageData();
    }
  }


  onResetCards() {
    this.editorService.getEditorData("reset");
  }
  onDeleteCard(cardObj) {
    this.editorService.getEditorData("delete");
  }
  onResetStage() {
    this.onResetCards();
  }
  sendPageSave(pageSaveData) {
    pageSaveData = JSON.parse(pageSaveData);
    this.autoSaveCard(pageSaveData);
  }



  onUndoStackEmpty(emptyState) {
    console.log(emptyState)
  }
  onRedoStackEmpty(emptyState) {
    console.log(emptyState)
  }
  sendLivePreviewState(state) {
    console.log(state);
  }


  autoSaveCard(pageContent) {
    if (this.bookObj && this.bookObj.bookCategory == 1 && this.rootTabActive)
      this.editorOptionsService.savePageContent(this.pageObj.contentDocId, pageContent);
    else
      this.editorOptionsService.savePageContent(this.currentLoadingPage.contentDocId, pageContent);
  }


}



// WEBPACK FOOTER //
// ./src/app/bookShared/editor/editor.component.ts